<ng-container *ngIf="isChatEnabled">
  <aside class="chat-pane" *ngIf="isChatOpen">
    <div class="chat-pane-header">
      <span class="chat-pane-title">AI Assistant</span>
      <div class="chat-pane-controls">
        <button type="button" class="chat-pane-close" (click)="closeChatPanel()">×</button>
      </div>
    </div>
    <div class="chat-pane-body">
      <div class="webchat-wrapper" [class.rai-waiting]="isWaitingForResponse" [class.has-status]="!!statusMessage">
        <div #documentViewerChatHost class="document-chat-host"></div>

        <div class="rai-status-indicator" *ngIf="statusMessage">
          <span class="rai-status-dots"></span>
          <span class="rai-status-text">{{ statusMessage }}</span>
        </div>
      </div>
    </div>
  </aside>
</ng-container>
